/**
 * 运行时环境变量，调用时确定值，不可在构建时确定
 * 因此不允许通过以下几种方式获取值
 * 1. process.env
 * 2. 直接在函数外部定义常量，如 const BASE_PATH = getBasePath()，因为这样会导致在构建时就确定了值
 * @returns
 */

import { getNativeInfo } from "../jsbridge"
import { getCookie } from "./cookie"

/** 是否为服务端 */
export function isServerSide(): boolean {
  return typeof window === "undefined"
}

export function getClientEnv(key: string): string | undefined {
  if (isServerSide()) {
    return process.env[key]
  }
  const envs = window.localStorage.getItem('NEXT_ENVS')

  if (envs) {
    const parsed = JSON.parse(envs)
    return parsed[key]
  }
}

export function isProduction(): boolean {
  if (isServerSide()) {
    return process.env['NODE_ENV'] === 'production'
  } else {
    // 从localStorage中获取
    return getClientEnv('NODE_ENV') === 'production'
  }
}

// community判断是否为qa环境
export function isPR(): boolean {
  if (isServerSide()) {
    return process.env["NEXT_PUBLIC_DEPLOY_ENV"] === "pr"
  } else {
    return getClientEnv("NEXT_PUBLIC_DEPLOY_ENV") === "pr"
  }
}

// 判断是否是eu环境
export async function getRegion(){
  let region = isServerSide() ? process.env['NEXT_PUBLIC_REGION'] : getClientEnv('NEXT_PUBLIC_REGION')
  // 社区没有eu环境，只部署了一套us服务
  if (!region) {
    try {
      const appinfo = await getNativeInfo();
      if (appinfo.domain) {
        if (appinfo.domain.includes("-eu")) {
          region = "eu";
        } else {
          region = "us";
        }
      }
    }catch(e){
      const country = getCookie("country")
      if (["US", "CA"].includes(country?.toUpperCase())) {
        region = "us";
      } else {
        window.location.href.includes('-eu') ? region = "eu" :
          region = "us";
      }  
      console.error('getRegion nativeInfo',e)
    }
  }

  return (region ?? 'us').toLowerCase()
}